module.exports = __webpack_public_path__ + "img/ANRM.ecd154e9.svg";